import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/lists';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.LIST);

export const useGetListById = ({ sessionToken, listId, queryOptions = {} }) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(listId),
        queryFn: () => Client.fetchOne(sessionToken, listId),
        onSuccess: (data) => {
            // console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: typeof listId !== 'undefined',
        ...queryOptions
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
